const createIntent = (server, reader) => {
  if (reader === 'wpe') {
    return `
{+fetch-intent}
- (void)createPaymentIntent:(void (^)(NSString *__nullable, NSError *__nullable))completion {
  NSURLSessionConfiguration *config = [NSURLSessionConfiguration defaultSessionConfiguration];
  NSURLSession *session = [NSURLSession sessionWithConfiguration:config delegate:nil delegateQueue:[NSOperationQueue mainQueue]];
  NSURL *url = [NSURL URLWithString:@"${
    server === 'php' ? '/create.php' : '/create'
  }" relativeToURL:[APIClient backendUrl]];
  if (!url) {
      NSAssert(NO, @"Invalid backend URL");
  }

  {+mobile-test-cards}
  NSString *parameters = [NSString stringWithFormat:@"{\\"amount\\":\\"%@\\"}", "1000"];
  {/mobile-test-cards}

  NSMutableURLRequest *request = [[NSMutableURLRequest alloc] initWithURL:url];
  request.HTTPMethod = @"POST";
  request.HTTPBody = [parameters dataUsingEncoding:NSUTF8StringEncoding];

  NSURLSessionDataTask *task = [session dataTaskWithRequest:request completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {
      id jsonObject = nil;
      NSError *jsonSerializationError;
      if (data) {
          jsonObject = [NSJSONSerialization JSONObjectWithData:data options:(NSJSONReadingOptions)kNilOptions error:&jsonSerializationError];
      }
      else {
          NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                code:1000
                                            userInfo:@{NSLocalizedDescriptionKey: @"No data in response from PaymentIntent endpoint"}];
          completion(nil, error);
      }
      if (!(jsonObject && [jsonObject isKindOfClass:[NSDictionary class]])) {
          completion(nil, jsonSerializationError);
          return;
      }
      NSDictionary *json = (NSDictionary *)jsonObject;

      id client_secret = json[@"client_secret"];
      if (!(client_secret && [client_secret isKindOfClass:[NSString class]])) {
          NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                code:2000
                                            userInfo:@{NSLocalizedDescriptionKey: @"Missing 'client_secret' in ConnectionToken JSON response"}];
          completion(nil, error);
          return;
      }

      completion((NSString *)client_secret, nil);
  }];
  [task resume];
}
{/fetch-intent}
`;
  }
};

export default ({keys, server, reader}) => {
  return `#import "APIClient.h"

@implementation APIClient

static APIClient *_shared = nil;

+ (NSURL *) backendUrl {
    return [NSURL URLWithString:@"http://localhost:4242"];
}

+ (instancetype)shared {
    static dispatch_once_t onceToken;
    dispatch_once(&onceToken, ^{
        _shared = [APIClient new];
    });
    return _shared;
}

{+fetch-connection-token}
- (void)fetchConnectionToken:(SCPConnectionTokenCompletionBlock)completion {
    NSURLSessionConfiguration *config = [NSURLSessionConfiguration defaultSessionConfiguration];
    NSURLSession *session = [NSURLSession sessionWithConfiguration:config];
    NSURL *url = [NSURL URLWithString:@"${
      server === 'php' ? '/token.php' : '/connection_token'
    }" relativeToURL:[APIClient backendUrl]];
    if (!url) {
        NSAssert(NO, @"Invalid backend URL");
    }
    NSMutableURLRequest *request = [[NSMutableURLRequest alloc] initWithURL:url];
    request.HTTPMethod = @"POST";
    NSURLSessionDataTask *task = [session dataTaskWithRequest:request completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {
        id jsonObject = nil;
        NSError *jsonSerializationError;
        if (data) {
            jsonObject = [NSJSONSerialization JSONObjectWithData:data options:(NSJSONReadingOptions)kNilOptions error:&jsonSerializationError];
        }
        else {
            NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                  code:1000
                                              userInfo:@{NSLocalizedDescriptionKey: @"No data in response from ConnectionToken endpoint"}];
            completion(nil, error);
        }
        if (!(jsonObject && [jsonObject isKindOfClass:[NSDictionary class]])) {
            completion(nil, jsonSerializationError);
            return;
        }
        NSDictionary *json = (NSDictionary *)jsonObject;
        id secret = json[@"secret"];
        if (!(secret && [secret isKindOfClass:[NSString class]])) {
            NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                  code:2000
                                              userInfo:@{NSLocalizedDescriptionKey: @"Missing 'secret' in ConnectionToken JSON response"}];
            completion(nil, error);
            return;
        }
        completion((NSString *)secret, nil);
    }];
    [task resume];
}
{/fetch-connection-token}
${createIntent(server, reader)}
{+capture-intent}
- (void)capturePaymentIntent:(NSString *)paymentIntentId
                  completion:(SCPErrorCompletionBlock)completion {
    NSURLSessionConfiguration *config = [NSURLSessionConfiguration defaultSessionConfiguration];
    NSURLSession *session = [NSURLSession sessionWithConfiguration:config];
    NSURL *url = [NSURL URLWithString:@"${
      server === 'php' ? '/capture.php' : '/capture_payment_intent'
    }" relativeToURL:[APIClient backendUrl]];

    NSString *parameters = [NSString stringWithFormat:@"{\\"id\\":\\"%@\\"}", paymentIntentId];

    NSMutableURLRequest *request = [[NSMutableURLRequest alloc] initWithURL:url];
    request.HTTPMethod = @"POST";
    request.HTTPBody = [parameters dataUsingEncoding:NSUTF8StringEncoding];

    NSURLSessionDataTask *task = [session dataTaskWithRequest:request
                                            completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
        if (response) {
            NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *) response;
            if (httpResponse.statusCode >= 200 && httpResponse.statusCode < 300) {
                completion(nil);
            } else if (httpResponse.statusCode == 402) {
                NSString *description = [[NSString alloc] initWithData:data encoding:NSUTF8StringEncoding];
                if (!description) {
                    description = @"Failed to capture payment intent";
                }

                NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                      code:2
                                                  userInfo:@{NSLocalizedDescriptionKey: description}];

                completion(error);
            } else {
                if(error) {
                    completion(error);
                } else {
                    NSError *error = [NSError errorWithDomain:@"com.stripe-terminal-ios.example"
                                                          code:0
                                                      userInfo:@{NSLocalizedDescriptionKey: @"Other networking error occurred"}];

                    completion(error);
                }
            }
        } else {
            completion(error);
        }
    }];

    [task resume];
}
{/capture-intent}

@end
`;
};
